import { Badge, Switch, VStack } from '@elkaso-app/web-design';
import { useState } from 'react';

interface VerificationSwitcherCellProps {
  locationId: number;
  isVerified: boolean;
  onVerifyChange: (locationId: number, isVerified: boolean) => Promise<void>;
  isLoading?: boolean;
}

export const VerificationRadioCell: React.FC<VerificationSwitcherCellProps> = ({
  locationId,
  isVerified,
  onVerifyChange,
  isLoading = false,
}) => {
  const [isChanging, setIsChanging] = useState(false);

  const handleToggle = async (checked: boolean) => {
    // Don't make API call if status hasn't actually changed
    if (checked === isVerified) {
      return;
    }

    setIsChanging(true);
    try {
      await onVerifyChange(locationId, checked);
    } catch (error) {
      // Error handling is done in the API hook
    } finally {
      setIsChanging(false);
    }
  };

  return (
    <div style={{ height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px 0' }}>
      <VStack align='center' spacing={2}>
        <Switch
          isChecked={isVerified}
          onChange={(e) => handleToggle(e.target.checked)}
          colorScheme='green'
          isDisabled={isLoading || isChanging}
          size='md'
        />
        <Badge colorScheme={isVerified ? 'green' : 'red'} variant='subtle' size='sm'>
          {isVerified ? 'Verified' : 'Unverified'}
        </Badge>
      </VStack>
    </div>
  );
};
